import React, { useState, useRef, useEffect } from "react";

const VideoPlayer = ({
  setLoadCounter,
  value,
  onePx,
  TickerPosition,
  CanvasDisplay,
}) => {
  const [VideoLoaded, setVideoLoaded] = useState(false);
  const videoref = useRef(null);
  const [CurrTime, setCurrTime] = useState(0);

  const isLoaded = () => {
    // (Was document.getElementById("VideosDiv-" + value): value is an object, so every video had
    // the id "VideosDiv-[object Object]" and only the first one got its volume.)
    if (videoref.current && typeof value.volume === "number") videoref.current.volume = value.volume;
    if (sessionStorage.getItem("LoadCounter")) {
      let array = JSON.parse(sessionStorage.getItem("LoadCounter"));
      array.push(value.previewKey);
      sessionStorage.setItem("LoadCounter", JSON.stringify(array));
      setLoadCounter(array);
    }
  };

  useEffect(() => {
    if (!videoref.current) return;
    if (value.player) {
      // play() is cut short whenever the preview pauses or seeks meanwhile; that is expected and
      // must not surface as an error.
      const p = videoref.current.play();
      if (p && typeof p.catch === "function") p.catch(() => {});
    } else {
      videoref.current.pause();
    }
  }, [value.player]);

  useEffect(() => {
    if (CurrTime != 0) {
      videoref.current.currentTime = CurrTime;
    }
  }, [CurrTime]);

  useEffect(() => {
    if (VideoLoaded) {
      if (
        value.startPositionOnTimeline <= TickerPosition &&
        value.startPositionOnTimeline + value.widthOnTimeline >= TickerPosition
      ) {
        let ms = (TickerPosition - value.startPositionOnTimeline) * onePx;
        var sec = (ms / 1000).toFixed(1);
        setCurrTime(sec);
        // videoref.current.currentTime = sec
      }
    }
  }, [value.player]);

  return (
    <>
      <div className={"VideosDiv"}>
        <video
          preload="true"
          id={"VideosDiv-" + value.AnimationId}
          ref={videoref}
          playsInline
          style={{
            width: "100%",
            height: "100%",
            transform:
              value.flip +
              (!CanvasDisplay ? `rotate(${value.rotateAngle}deg)` : ""),
            opacity: value.opacity,
          }}
          src={value.url}
          onLoadedData={() => {
            setVideoLoaded(true);
            isLoaded();
          }}
        />
      </div>
    </>
  );
};

export default VideoPlayer;
